var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlowChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 14.0209C4.25 14.4214 4.57637 14.75 4.98376 14.75H6.5152C6.92389 14.75 7.24994 14.4211 7.24994 14.0209V9.9781C7.24994 9.5786 6.92453 9.25 6.5152 9.25H4.98376C4.57573 9.25 4.25 9.5783 4.25 9.9781V14.0209ZM4.98376 16.25C3.7527 16.25 2.75 15.2546 2.75 14.0209V9.9781C2.75 8.7438 3.75334 7.75 4.98376 7.75H6.5152C7.74628 7.75 8.74994 8.7435 8.74994 9.9781V14.0209C8.74994 15.2549 7.74692 16.25 6.5152 16.25H4.98376Z",
    fill: "#3F906D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.75 19.5209C16.75 19.9214 17.0764 20.25 17.4838 20.25H19.0152C19.4239 20.25 19.7499 19.9211 19.7499 19.5209V15.4781C19.7499 15.0786 19.4245 14.75 19.0152 14.75H17.4838C17.0757 14.75 16.75 15.0783 16.75 15.4781V19.5209ZM17.4838 21.75C16.2527 21.75 15.25 20.7546 15.25 19.5209V15.4781C15.25 14.2438 16.2533 13.25 17.4838 13.25H19.0152C20.2463 13.25 21.2499 14.2435 21.2499 15.4781V19.5209C21.2499 20.7549 20.2469 21.75 19.0152 21.75H17.4838Z",
    fill: "#3F906D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.75 8.5209C16.75 8.9214 17.0764 9.25 17.4838 9.25H19.0152C19.4239 9.25 19.7499 8.9211 19.7499 8.5209V4.4781C19.7499 4.0786 19.4245 3.75 19.0152 3.75H17.4838C17.0757 3.75 16.75 4.0783 16.75 4.4781V8.5209ZM17.4838 10.75C16.2527 10.75 15.25 9.7546 15.25 8.5209V4.4781C15.25 3.2438 16.2533 2.25 17.4838 2.25H19.0152C20.2463 2.25 21.2499 3.2435 21.2499 4.4781V8.5209C21.2499 9.7549 20.2469 10.75 19.0152 10.75H17.4838Z",
    fill: "#3F906D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 12C7.25 11.5858 7.58579 11.25 8 11.25H12C12.4142 11.25 12.75 11.5858 12.75 12C12.75 12.4142 12.4142 12.75 12 12.75H8C7.58579 12.75 7.25 12.4142 7.25 12Z",
    fill: "#3F906D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 15.5C12.75 16.1904 13.3096 16.75 14 16.75H16C16.4142 16.75 16.75 17.0858 16.75 17.5C16.75 17.9142 16.4142 18.25 16 18.25H14C12.4812 18.25 11.25 17.0188 11.25 15.5V8.5C11.25 6.9812 12.4812 5.75 14 5.75H16C16.4142 5.75 16.75 6.0858 16.75 6.5C16.75 6.9142 16.4142 7.25 16 7.25H14C13.3096 7.25 12.75 7.8096 12.75 8.5V15.5Z",
    fill: "#3F906D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowChart);
export default __webpack_public_path__ + "static/media/flow-chart.b31cf36d2033c3f1d17f326aee4af8f2.svg";
export { ForwardRef as ReactComponent };